import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent.js';

const Countries = asyncComponent(() =>
  import('../../containers/authorised/manageCountries/countries/Countries.js')
);

const CountryPricing = asyncComponent(() =>
  import('../../containers/authorised/manageCountries/country/pricing/Pricing.js')
);

const CountryAddOns = asyncComponent(() =>
  import('../../containers/authorised/manageCountries/country/addOns/AddOns.js')
);

const ManageCountriesRoutes = (
  <Switch>
    <Route exact path="/manage-countries" component={Countries} />
    <Route exact path="/manage-countries/:id/pricing" component={CountryPricing} />
    <Route exact path="/manage-countries/:id/add-ons" component={CountryAddOns} />
    <Redirect exact from="/manage-countries/:id" to="/manage-countries/:id/pricing" />
  </Switch>
);

export default ManageCountriesRoutes;